"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
var TeamRemove = function TeamRemove(props) {
  var _a = props,
    className = _a.className,
    _a$size = _a.size,
    size = _a$size === void 0 ? IconSize.Medium : _a$size,
    _a$color = _a.color,
    color = _a$color === void 0 ? "inherit" : _a$color,
    rest = __objRest(_a, ["className", "size", "color"]);
  var iconClass = classNames(styles.icon({
    size: size,
    color: color
  }), "kl-icon", "kl-icon--".concat(size), className);
  return React.createElement("svg", __spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: iconClass
  }, rest), /* @__PURE__ */React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 24a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM2 20h5v-1H2v1z",
    clipRule: "evenodd"
  }), /* @__PURE__ */React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 7.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM21.735 18h-6.759c.016-.08.024-.163.024-.25v-5.263c0-.498-.11-.96-.304-1.376a4.84 4.84 0 002.54.712A4.837 4.837 0 0019.946 11c1.14.033 2.053.942 2.053 2.058v4.685a.261.261 0 01-.265.257zM13 13.058V18h.714c.158 0 .286-.112.286-.25v-5.263c0-.359-.086-.7-.24-1.008-.465.377-.76.945-.76 1.58z",
    clipRule: "evenodd",
    opacity: 0.6
  }), /* @__PURE__ */React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 9a3 3 0 100-6 3 3 0 000 6zm3.494 1c-.984.62-2.19.984-3.494.984A6.556 6.556 0 014.506 10C3.094 10.152 2 11.207 2 12.487V14.6A5.502 5.502 0 019.793 18h3.921c.158 0 .286-.112.286-.25v-5.263c0-1.28-1.094-2.335-2.506-2.487z",
    clipRule: "evenodd"
  }));
};
export default TeamRemove;